<template>
    <b-button-group class="btn-block">
        <b-button class="btn-step" squared @click="$router.back()" :aria-label="$t('footer.return')">
            <b-icon-arrow-left class="left" aria-hidden="true"/> {{$t('footer.return')}}
        </b-button>
        <b-button
            class="btn-step"
            type="submit"
            :disabled="submitStatus === 'PENDING'"
            squared>
                {{ nextValue }} <b-icon-arrow-right aria-hidden="true"/>
        </b-button>
    </b-button-group>
</template>

<script>
export default {
  name: 'checkinfootermiddle',
  props: {
    step: String,
    nextValue: String,
    submitStatus: String
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
